export default {
  restricted: {
    title: "Acceso restringido",
    description: "Debes estar conectado para acceder a esta página.",
    login: "Iniciar sesión"
  },
  denied: {
    title: "Acceso denegado",
    description: "No tienes los permisos necesarios para acceder a esta página.",
    back: "Volver al inicio"
  },
  expired: {
    title: "Sesión expirada",
    description: "Tu sesión ha expirado. Por favor, inicia sesión de nuevo.",
    login: "Iniciar sesión de nuevo"
  },
  invitation: {
    title: "Invitación requerida",
    description: "Necesitas una invitación para acceder a este recurso.",
    contact: "Contacta al administrador para obtener una invitación."
  },
  subscriptionRequired: {
    title: "Suscripción requerida",
    description: "Esta funcionalidad requiere una suscripción activa.",
    upgrade: "Actualizar"
  }
};

